import { Model } from 'dva'
import { TelephonyService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'
import { BlacklistNumber } from './types'

const BlacklistNumbers: Model = {
  namespace: 'blacklistNumbers',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let blacklistNumbers = yield select((state: any) => state.blacklistNumbers.list)
        if (!(blacklistNumbers.length > 0 && useCache)) {
          blacklistNumbers = yield call(TelephonyService.telephonyBlacklistNumbersList, {})
          yield put({ type: 'modifyList', payload: blacklistNumbers })
        }
        onSuccess(blacklistNumbers)
      } catch (err: any) {
        FailureHandler('Error fetching blacklistNumbers', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyBlacklistNumbersCreate, {
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a blacklistNumber', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { caller_number, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        console.log(`caller_number = ${caller_number}`)
        yield call(TelephonyService.telephonyBlacklistNumbersDestroy, { number: caller_number })

        yield put({ type: 'modifyList', payload: caller_number })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a blacklistNumber', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: BlacklistNumber) => l.caller_number !== action.payload.caller_number)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter(
            (l: BlacklistNumber) =>
              !action.payload.map((p: BlacklistNumber) => p.caller_number).includes(l.caller_number)
          )
          .concat(action.payload)
      } else if (typeof action.payload === 'string') {
        // if the payload is an integer, it's an caller_number sent in delete operations, so remove it from the list
        list = list.filter((l: BlacklistNumber) => l.caller_number !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetBlacklistNumbers(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default BlacklistNumbers
